import React from 'react';
import { motion } from 'framer-motion';

const technologies = [
  { name: 'OpenAI GPT-4', category: 'AI' },
  { name: 'Anthropic Claude', category: 'AI' },
  { name: 'Twilio', category: 'Communication' },
  { name: 'WhatsApp', category: 'Communication' },
  { name: 'PostgreSQL', category: 'Database' },
  { name: 'Pinecone', category: 'Vector DB' },
  { name: 'Redis', category: 'Cache' },
  { name: 'Stripe', category: 'Payments' },
];

export const Technology: React.FC = () => {
  return (
    <section className="relative py-24">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            Built on <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">Best-in-Class</span> Technology
          </h2>
          <p className="text-xl text-gray-400">Enterprise-grade integrations and security</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {technologies.map((tech, index) => (
            <motion.div
              key={tech.name}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: index * 0.05 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              className="bg-gray-800/50 backdrop-blur-lg border border-gray-700 rounded-xl p-6 text-center group hover:border-purple-500/50 transition-all"
            >
              <div className="text-2xl font-bold text-white mb-2">{tech.name}</div>
              <div className="text-sm text-gray-400">{tech.category}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
